var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.396,
    height: 70.625,
    viewBox: "0 0 68.396 70.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_122549",
    "data-name": "Group 122549",
    transform: "translate(723.775 -22222.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171717",
    "data-name": "Path 171717",
    d: "M334.653,29.143h-7.2c0-3.757,0-7.207,0-10.657,0-6.195-6.231-12.889-12.464-13.035-3.385-.079-6.327,1.281-7.022,5.029s1.768,5.585,4.955,6.2a96.126,96.126,0,0,0,9.729.907V29.453c-7.606,0-15.037.115-22.456-.141-.958-.033-2.063-1.872-2.7-3.086-.411-.786.035-1.974-.116-2.949-.736-4.742,1.1-6.834,5.969-6.059a11.719,11.719,0,0,0,2.736-.3c-2.316-4.761-2-8.911,2.063-12.25A9.618,9.618,0,0,1,319.3,3.429a29.959,29.959,0,0,1,6.923,4.722c5.124,4.838,5.021,4.94,9.871.056a26.609,26.609,0,0,1,2.537-2.391c4.964-3.838,10.3-4.639,14.3-1.986,4.769,3.161,5.408,7.611,3.31,12.7a5.851,5.851,0,0,0,1.521.625c7.118.388,9.042,2.864,7.2,9.83a4.073,4.073,0,0,1-3.016,2.319c-7.289.2-14.586.106-22.217.106V17.217c2.486,0,5.06.511,7.3-.135a16,16,0,0,0,6.919-4c.728-.759-.044-4.546-1.115-5.118-2.355-1.257-5.563-2.308-8.016-1.726-6.839,1.624-10.189,6.7-10.168,13.756.008,2.949,0,5.9,0,9.146",
    transform: "translate(-1021 22220)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171718",
    "data-name": "Path 171718",
    d: "M300.413,34.485H322.53V72.392c-5.552,0-11.358.508-16.983-.279-1.944-.272-4.8-3.7-4.9-5.8-.506-10.431-.231-20.9-.231-31.825",
    transform: "translate(-1021 22220)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171719",
    "data-name": "Path 171719",
    d: "M339.61,72.6V34.666h22.3c0,10.709.355,21.153-.28,31.537-.138,2.245-3.576,5.674-5.945,6.111-5.1.94-10.493.289-16.076.289",
    transform: "translate(-1021 22220)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69489",
    "data-name": "Rectangle 69489",
    width: 6.354,
    height: 38.092,
    transform: "translate(-693.166 22254.416)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.827d7222358b0c55414a79a2375934d8.svg";
export { ForwardRef as ReactComponent };